import React, { useState } from "react";
import { Button, Input, Select, Space, Table, message } from "antd";
import axios from "axios";
import config from "../services/config.json";

const PhoneLogs = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [filters, setFilters] = useState({
    phone_number: "",
    type: "whatsapp",
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: 0,
  });

  const fetchData = async (params = {}) => {
    const currentFilters = params.filters || filters;
    setLoading(true);

    try {
      const response = await axios.get(`${config.apiEndPoint}get_phone_logs`, {
        params: {
          page: params.pagination?.current || 1,
          per_page: params.pagination?.pageSize || 15,
          phone_number: currentFilters.phone_number,
          type: currentFilters.type,
        },
      });

      const result = response.data;
      setData(result.data || []);
      setPagination({
        current: result.current_page || params.pagination?.current || 1,
        pageSize: result.per_page || params.pagination?.pageSize || 15,
        total: result.total || 0,
      });
      setHasSearched(true);
    } catch (error) {
      console.error("Failed to fetch phone logs:", error);
      message.error("Failed to fetch phone logs");
    }

    setLoading(false);
  };

  const handleSearch = () => {
    const phoneNumber = filters.phone_number.trim();

    if (!phoneNumber) {
      message.warning("Phone number is required");
      return;
    }

    if (!filters.type) {
      message.warning("Please select WhatsApp or Phone");
      return;
    }

    const nextFilters = { ...filters, phone_number: phoneNumber };
    setFilters(nextFilters);
    fetchData({ pagination: { ...pagination, current: 1 }, filters: nextFilters });
  };

  const handleTableChange = (nextPagination) => {
    if (!hasSearched) return;
    fetchData({ pagination: nextPagination, filters });
  };

  const columns = [
    {
      title: "No.",
      key: "index",
      render: (text, record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Phone Number",
      key: "phone_number",
      render: (record) =>
        record.phone_number || record.phone || record.number || record.mobile || "-",
    },
    {
      title: "Origin",
      dataIndex: "origin",
      key: "origin",
    },
    {
      title: "Ad Campaign",
      dataIndex: "ad_number",
      key: "ad_number",
    },
    {
      title: "Compaign Source",
      dataIndex: "compaign_source",
      key: "compaign_source",
    },
    {
      title: "Page",
      dataIndex: "page_url",
      key: "page_url",
    },
    {
      title: "Time",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "IP Address",
      dataIndex: "ip_address",
      key: "ip_address",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <h2>Phone Logs</h2>

      <Space wrap style={{ marginBottom: 16, marginTop: 25 }}>
        <Input
          placeholder="Enter phone number"
          value={filters.phone_number}
          onChange={(e) => setFilters({ ...filters, phone_number: e.target.value })}
          onPressEnter={handleSearch}
          style={{ width: 240 }}
        />

        <Select
          placeholder="Select type"
          value={filters.type || undefined}
          onChange={(value) => setFilters({ ...filters, type: value })}
          options={[
            { value: "whatsapp", label: "WhatsApp" },
            { value: "phone", label: "Phone" },
          ]}
          style={{ width: 180 }}
        />

        <Button type="primary" onClick={handleSearch} loading={loading}>
          Search
        </Button>
      </Space>

      <Table
        columns={columns}
        rowKey={(record, index) => record.id || index}
        dataSource={hasSearched ? data : []}
        pagination={hasSearched ? pagination : false}
        loading={loading}
        onChange={handleTableChange}
        locale={{ emptyText: hasSearched ? "No logs found" : "Search to view phone logs" }}
      />
    </div>
  );
};

export default PhoneLogs;